import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Search, Bell, Users, CreditCard, Puzzle, Settings, LogOut, X, ShieldCheck, Inbox, Bookmark } from 'lucide-react';
import { Logo } from './Logo';
interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}
export function Sidebar({
  isOpen,
  onClose
}: SidebarProps) {
  const navigate = useNavigate();
  // Mock admin state
  const isAdmin = true;
  const navSections = [{
    title: 'PRINCIPAL',
    items: [{
      path: '/inbox',
      label: 'Bandeja de Entrada',
      icon: Inbox,
      badge: 7
    }, {
      path: '/busquedas',
      label: 'Búsquedas',
      icon: Search
    }, {
      path: '/alertas',
      label: 'Alertas',
      icon: Bell
    }, {
      path: '/guardados',
      label: 'Guardados',
      icon: Bookmark
    }]
  }, {
    title: 'GESTIÓN',
    items: [{
      path: '/equipo',
      label: 'Equipo',
      icon: Users
    }, {
      path: '/facturacion',
      label: 'Facturación',
      icon: CreditCard
    }, {
      path: '/integraciones',
      label: 'Integraciones',
      icon: Puzzle
    }]
  }];
  if (isAdmin) {
    navSections.push({
      title: 'ADMINISTRACIÓN',
      items: [{
        path: '/admin',
        label: 'Panel Admin',
        icon: ShieldCheck
      }]
    });
  }
  const handleLogout = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigate('/');
  };
  return <>
      {/* Mobile overlay */}
      {isOpen && <div className="fixed inset-0 bg-navy-950/50 z-40 lg:hidden backdrop-blur-sm" onClick={onClose} data-id="element-143" />}

      {/* Sidebar */}
      <aside className={`
        fixed lg:static inset-y-0 left-0 z-50
        w-[260px] bg-navy-800 border-r border-navy-950/10
        flex flex-col transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `} data-id="element-144">
        <div className="h-14 px-6 flex items-center justify-between shrink-0 border-b border-white/5" data-id="element-145">
          <Logo variant="negative" data-id="element-146" />
          <button onClick={onClose} className="lg:hidden text-slate-400 hover:text-white transition-colors" data-id="element-147">
            <X size={20} data-id="element-148" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto py-6 px-3 space-y-8" data-id="element-149">
          {navSections.map(section => <div key={section.title} data-id="element-150">
              <h3 className="px-3 text-[11px] font-semibold text-slate-400 uppercase tracking-wider mb-2" data-id="element-151">
                {section.title}
              </h3>
              <nav className="space-y-0.5" data-id="element-152">
                {section.items.map(item => <NavLink key={item.path} to={item.path} onClick={() => {
              if (window.innerWidth < 1024) onClose();
            }} className={({
              isActive
            }) => `
                      flex items-center justify-between px-3 py-2 rounded-md text-sm font-medium transition-all relative
                      ${isActive ? 'text-white bg-white/5' : 'text-slate-400 hover:text-white hover:bg-white/5'}
                    `} data-id="element-153">
                    {({
                isActive
              }) => <>
                        {isActive && <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[3px] h-5 bg-brand-500 rounded-r-full" data-id="element-154" />}
                        <div className="flex items-center gap-3" data-id="element-155">
                          <item.icon size={18} className={isActive ? 'text-brand-500' : ''} data-id="element-156" />
                          {item.label}
                        </div>
                        {item.badge && <span className="bg-brand-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full min-w-[20px] text-center" data-id="element-157">
                            {item.badge}
                          </span>}
                      </>}
                  </NavLink>)}
              </nav>
            </div>)}
        </div>

        <div className="p-3 border-t border-white/5 space-y-0.5" data-id="element-158">
          <NavLink to="/perfil" className={({
          isActive
        }) => `
              w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-all
              ${isActive ? 'text-white bg-white/5' : 'text-slate-400 hover:text-white hover:bg-white/5'}
            `} data-id="element-159">
            <Settings size={18} data-id="element-160" />
            Configuración
          </NavLink>

          <div onClick={() => navigate('/perfil')} className="mt-2 pt-2 border-t border-white/5 flex items-center justify-between px-3 py-2 group cursor-pointer hover:bg-white/5 rounded-md transition-all" data-id="element-161">
            <div className="flex items-center gap-3" data-id="element-162">
              <div className="w-8 h-8 rounded-full bg-brand-500/20 text-brand-400 flex items-center justify-center text-xs font-semibold border border-brand-500/30" data-id="element-163">
                DR
              </div>
              <div className="flex flex-col" data-id="element-164">
                <span className="text-sm font-medium text-white leading-none" data-id="element-165">
                  Dr. Rossi
                </span>
                <span className="text-xs text-slate-400 mt-1 leading-none" data-id="element-166">
                  Admin
                </span>
              </div>
            </div>
            <button onClick={handleLogout} className="text-slate-400 opacity-0 group-hover:opacity-100 hover:text-rose-500 transition-all p-1" title="Cerrar sesión" data-id="element-167">
              <LogOut size={16} data-id="element-168" />
            </button>
          </div>
        </div>
      </aside>
    </>;
}